import React from 'react'

function TitleLine({title}) {
  return (
<div class="eleven mt-4">
  <h1>{title}</h1>
</div>
       
  )
}

export default TitleLine